"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    textVariants: function() {
        return textVariants;
    },
    Text: function() {
        return Text;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var textVariants = [
    "text-header-4XL",
    "text-header-3XL",
    "text-header-2XL",
    "text-header-XL",
    "text-header-L",
    "text-header-M",
    "text-header-S",
    "text-header-XS",
    "text-body-display-2XL",
    "text-body-display-XL",
    "text-body-display-L",
    "text-body-display-M",
    "text-body-display-S",
    "text-body-display-XS",
    "text-body-large-regular",
    "text-body-large-medium",
    "text-body-large-bold",
    "text-body-regular",
    "text-body-medium",
    "text-body-bold",
    "text-body-meta-regular",
    "text-body-meta-medium",
    "text-body-meta-bold",
    "text-body-floating-label-regular",
    "text-body-floating-label-medium",
    "text-body-floating-label-bold",
    "text-link-body-large",
    "text-link-body-medium",
    "text-link-body-small"
];
var variants = textVariants.reduce(function(acc, v) {
    return _object_spread(_define_property({}, v, {
        textStyle: v
    }), acc);
}, {});
var Text = {
    variants: variants,
    defaultProps: {
        variant: "text-body-regular"
    }
};
